"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareGranteeBase = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var ConfirmDialogBase_1 = require("../../ConfirmDialogBase");
var ContentDivider_1 = require("./ContentDivider");
var ShareGranteeContent_1 = require("./ShareGranteeContent");
var SharedObjectUnderLenientControl_1 = require("./SharedObjectUnderLenientControl");
var SharedObjectLockControl_1 = require("./SharedObjectLockControl");
/**
 * @internal
 */
exports.ShareGranteeBase = function (props) {
    var isLoading = props.isLoading, isLockedNow = props.isLockedNow, isUnderLenientControlNow = props.isUnderLenientControlNow, grantees = props.grantees, sharedObject = props.sharedObject, isDirty = props.isDirty, onCancel = props.onCancel, onSubmit = props.onSubmit, onGranteeDelete = props.onGranteeDelete, onAddGranteeButtonClick = props.onAddGranteeButtonClick, onLockChange = props.onLockChange, onUnderLenientControlChange = props.onUnderLenientControlChange;
    var owner = sharedObject.owner, isLeniencyControlSupported = sharedObject.isLeniencyControlSupported, isLockingSupported = sharedObject.isLockingSupported;
    var intl = react_intl_1.useIntl();
    var granteeList = react_1.useMemo(function () {
        return tslib_1.__spread([owner], grantees);
    }, [grantees, owner, intl]);
    var dialogLabels = react_1.useMemo(function () {
        return {
            headline: intl.formatMessage({ id: "shareDialog.share.grantee.title" }),
            cancelButtonText: intl.formatMessage({ id: "cancel" }),
            submitButtonText: intl.formatMessage({ id: "save" }),
        };
    }, []);
    return (react_1.default.createElement(ConfirmDialogBase_1.ConfirmDialogBase, { className: "gd-share-dialog s-gd-share-grantees", displayCloseButton: true, isPositive: true, isSubmitDisabled: !isDirty, headline: dialogLabels.headline, cancelButtonText: dialogLabels.cancelButtonText, submitButtonText: dialogLabels.submitButtonText, onCancel: onCancel, onSubmit: onSubmit },
        react_1.default.createElement(ShareGranteeContent_1.ShareGranteeContent, { isLoading: isLoading, grantees: granteeList, onAddGrantee: onAddGranteeButtonClick, onDelete: onGranteeDelete }),
        react_1.default.createElement(ContentDivider_1.ContentDivider, null),
        react_1.default.createElement(SharedObjectUnderLenientControl_1.SharedObjectUnderLenientControl, { isUnderLenientControl: isUnderLenientControlNow, isLeniencyControlSupported: isLeniencyControlSupported, onUnderLenientControlChange: onUnderLenientControlChange }),
        react_1.default.createElement(SharedObjectLockControl_1.SharedObjectLockControl, { isLocked: isLockedNow, isLockingSupported: isLockingSupported, onLockChange: onLockChange })));
};
//# sourceMappingURL=ShareGranteeBase.js.map